// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tuuhp","title":"styles_title__ufJlR"};